'use strict';

module.exports = require('react').PropTypes;



//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react/static-7.41/prop-types.js
// module id = 9
// module chunks = 0